// faqData.js

export const getFaqData = (agent) => {
  const commonFaqItems = [
    {
      question: 'How do I apply for RDP House',
      answer: `Please be advised that all applications for BNG/RDP housing is via registration on the housing demand database/waiting list of your local municipality.
The applicants need to contact their local municipality to register to wait in line for a BNG/RDP housing opportunity.
It is important to note that each local municipality remains responsible for beneficiary administration process, as well as the allocation of housing opportunities to qualifying beneficiaries.
Successful applicants are allocated according to their date of registration. The minimum criteria that apply, is that applicants must be on the waiting list for a minimum period of 10years, and their combined household monthly income must not exceed R3500.
Applicants are therefore advised to contact/visit their local municipality or nearest housing office to register on the waiting list.`,
    },
    {
      question: 'How do I register on the waiting list',
      answer: `The applicants need to contact their local municipality to register to wait in line for a BNG/RDP housing opportunity.`,
    },
    {
      question: 'I am registered on the waiting list, I want to check my status',
      answer: `All waiting list related enquiries should be directed to your local municipal authority.
It is important to note that each local municipality remains responsible for the beneficiary administration process, as well as the allocation of housing opportunities to qualifying beneficiaries.`,
    },
    {
      question: 'I am registered on the waiting list, when will I get a house',
      answer: `Successful applicants are allocated according to their date of registration. The minimum criteria that apply, is that applicants must be on the waiting list for a minimum period of 10years, and their combined household monthly income must not exceed R3500.`,
    },
    {
      question: 'How to I update/amend my personal information on the waiting list',
      answer: `Please visit your nearest housing office or your local municipal office to update your information.`,
    },
    {
      question: 'My parent(s) were on the waiting list, but passed away, will I get the house',
      answer: `No, unfortunately the position on the waiting list in not transferable. If you 18 years and older, you must register on the waiting list. If the beneficiary passed awaiting allocation, after the signing of a deed of sale, the spousal/co applicant/beneficiaries listed will be eligible to receive the house.`,
    },
    {
      question: 'How do I apply for a subsidy',
      answer: `Applications and enquiries can be made directly at the Western Cape Department of Infrastructure.
Visit 27 Wale Street, Cape Town
Call the Help Desk on 021 483 6488/0611/0623/2060/3112 (Monday to Friday from 07:30 – 15:00)
Email human.settlements@westerncape.gov.za; or
Visit the departmental website: www.westerncape.gov.za/department-of-infrastructure`,
    },
    {
      question: 'Do I qualify to apply for a subsidy',
      answer: `Your household income determines which subsidy you qualify for. If you earn between R0 – R3500 combined household income, you can explore the Non-Credit Linked Individual Subsidy. You qualify for this subsidy if:
You are registered on the housing demand database at your nearest municipality.
You have been on the municipal housing demand database (i.e. waiting list) for a minimum period of 10 years in Cape Town and 5 years in areas outside of Cape Town.
You are a South African citizen or have a permanent residency permit.
You are 18 years or older.
You are married or living with a partner.
You are single or divorced and have proven financial dependents permanently living with you.
Your maximum monthly household income is R0 to R 3 500 before deductions.
You or your partner have never owned property or in exceptional cases where the final order of divorce leaves all immovable property to one person, a person owns a portion e.g. A fifth of a property bequeathed in an estate and where a person owns a vacant stand bought without State assistance.
You or your partner have never received a subsidy from the government before.
Please note that priority will be given to applicants who are either aged or have special needs (e.g. disabled persons). There is a limited budget, therefore assistance is provided on a first come first serve basis.

If you earn between R 3500 – R22 000 combined household income, you could explore First Home Finance. What you need to qualify:
• Your gross household income is between R3,501 and R22,000 per month, ie. Basic household income, plus housing allowance where applicable.
• You are a South African citizen or have a permanent residency permit.
• You are over 18 years and competent to contract.
• You are married or cohabiting OR single with financial dependents.
• You haven’t received a government housing subsidy before.
• You haven’t owned fixed residential property before.
• Attorneys to be CSD registered and attach proof.`,
    },
    {
      question: 'I applied for subsidy, I want to check my application status',
      answer: `Please provide your 13-digit ID nr, so we verify on the Housing Subsidy System`,
    },
    {
      question: 'I am interested in buying a vacant plot/piece of land',
      answer: `Please approach your local municipality, to enquire. All vacant land is disposed of via public tender process.`,
    },
    {
      question: 'I want to buy a plot with a subsidy, how do I apply',
      answer: `Applications and enquiries can be made directly at the Western Cape Department of Infrastructure.
Visit 27 Wale Street, Cape Town
Call the Help Desk on 021 483 6488/0611/0623/2060/3112 (Monday to Friday from 07:30 – 15:00)
Email human.settlements@westerncape.gov.za; or
Visit the departmental website: www.westerncape.gov.za/department-of-infrastructure`,
    },
    {
      question: 'I am a Military Veteran, how do I apply for a subsidy',
      answer: `All Military Veterans must register for the Housing Benefit first via the Department of Military Veterans. Once the registration is confirmed, the beneficiary must approach his/her local municipal authority to register within a project.`,
    },
    {
      question: 'How do I apply for Social Housing',
      answer: `Social Housing aimed at households earning between R1 501 – R22 000 per month.
Applicants may apply at the individual institutions directly. Please see contact information below:

Institution           Telephone number               Website
Communicare          021 421 6008                   www.communicare.co.za
SOHCO                021 702 6007/8 or 031 201 4165 www.sohco.co.za
POVICOM              021 761 0707                   www.povicom.co.za
Own Haven            086 1696 428                   www.ownhaven.co.za
DCI CHS              021 552 5088                   http://dcichs.co.za/
Madulammoho          011 725 3284 / 021 981 8875    www.mh.org.za
Instratin            010 534 6900 / 011 656 1483    www.instratin.com
Urban Status Rentals (Devmark) 021 948 3502        www.devmark.co`,
    },
    {
      question: 'How do I obtain my title deed',
      answer: `First issue of your title deed is via your local municipal authority. If you have never received a title deed, please approach your local municipal authority. To obtain a copy of your title deed after 1st issue, please contact your nearest Deeds Office via the Department of Rural Development and Land Reform.`,
    },
    {
      question: 'I inherited an RDP/BNG house, how do I get it onto my name',
      answer: `Check for a will: If the previous owner left a will, you could see if you are named as a beneficiary.
Check if you are on the list of dependants: You can check with the municipal office where the previous owner applied for the house to see if you are listed as a dependant.
Get a letter of authority: You can get a letter of authority from the Master of the High Court.
Use a conveyancing attorney: A conveyancing attorney can help you transfer the title deed into your name. They will:
Sign the title deed into your name
File a copy in the Deeds Office
Pay a fee: You will need to pay a fee.
Get the Registrar to sign: You will only legally own the property when the Registrar of Deeds signs the transfer.
If the previous owner never had a title deed, you could apply to the high court for a declaratory order.`,
    },
    {
      question: 'I have been approved for a house, when will I get my house',
      answer: `Allocation of approved beneficiaries is the responsibility of each local municipality. Please remain in contact with your local municipality.`,
    },
    {
      question: 'There are damages to my new property, I need assistance',
      answer: `If the damages occurred during the warranty period, it can be reported to the Project Management Team for assistance. Kindly provide the relevant details. A consultant will be in touch shortly.`,
    },
    {
      question: 'The traffic lights are not working, how can it be reported',
      answer: `Kindly provide location details of where the lights are faulty so we may get the relevant authority to investigate and arrange for assistance. A consultant will be in touch shortly.`,
    },
    {
      question: 'The streetlights on portion of road are faulty, how can it be reported',
      answer: `Kindly provide location details of where the lights are faulty so we may get the relevant authority to investigate and arrange for assistance. A consultant will be in touch shortly.`,
    },
    {
      question: 'How do I verify ownership of a property',
      answer: `Kindly provide erf nr/property owner information (name, surname, ID) and/or suburb to verify via the Deeds register. A consultant will be in touch shortly.`,
    },
    {
      question: 'The bushes along a road need clearing/clean up, how can it be reported',
      answer: `Kindly provide location details of where the bush clearing/clean up so we may get the relevant authority to investigate and arrange for assistance.`,
    },
    {
      question: 'Where do I report illegal dumping on a vacant piece of land',
      answer: `Please contact your local municipal authority to report the illegal dumping. The relevant custodian will be informed of the activity.`,
    },
    {
      question: 'I have a proposal/innovation idea I want to share; how do I get in touch with the Minister',
      answer: `Our Supply Chain Management Directorate is best place to assist you. One of our officials will contact you within 72 business hours. Please provide contact information.`,
    },
    {
      question: 'I would like to apply for a bursary',
      answer: `The Masakh’iSizwe (MiS) Bursary awards external bursaries for studies at Higher Education Institutions (HEIs) in the Western Cape Province (WCP) for a field of study relating to a degree or diploma in the transport, engineering and built environment or any other disciplines deemed to be scarce and critical by the Department of Infrastructure.
It partnered with higher education institutions (HEI), non-governmental organisations (NGOs) and the relevant professional bodies to develop professionals in engineering and the built environment fields by offering bursaries to study towards a degree or higher diploma in the following disciplines:
Property studies
Geomatics
Transport economics
Transportation engineering
Mechatronics
Electrical and/or electronic engineering
Civil engineering
Construction management
Mechanical engineering
Quantity surveying
Town/City and regional planning
Architecture, etc.`,
    },
    {
      question: 'I would like to apply for an internship',
      answer: `All vacant positions/internships within the Western Cape Government, are advertised online at https://www.westerncape.gov.za/jobs/`,
    },
    {
      question: 'What is Deferred ownership',
      answer: `Deferred Ownership also known as "Rent-to-Own" or "Rent-to-Buy", is a pilot project in the Western Cape that allows people to rent a house for a set period of time before purchasing it.`,
    },
    {
      question: 'How do I apply for Deferred Ownership?',
      answer: `To qualify, applicants must be South African citizens or permanent residents, have a gross combined monthly income between R3,501 and R22,000, and not have previously owned property or received a government housing subsidy.
If an applicant is creditworthy, they can apply for a mortgage bond and a FLISP subsidy to buy a home. If they are not creditworthy, they can register for the "Rent-to-Own" option. During the rental period, the applicant receives support to improve their creditworthiness. After 24 months, they can choose to purchase the property.`,
    },
    {
      question: 'Where can I find Deferred Ownership Projects?',
      answer: `The Mill Park Development in Bredasdorp was the first Deferred Ownership project in the Western Cape. The project was part of the Finance Linked Individual Subsidy Programme (FLISP).
The Western Cape government also has an Inclusionary Housing Framework Policy that helps local governments plan with private developers to create more housing options for people who can't afford to buy.`,
    },
  ];

  return [
    {
      category: 'all',
      title: 'All',
      items: commonFaqItems,
    },
  ];
};
